import { Link } from 'react-router-dom';
import { Instagram, Facebook, Linkedin, Youtube, ArrowUpRight } from 'lucide-react';
import { SITE_NAME, SOCIAL_LINKS } from '@/lib/constants';

/**
 * Modern & Corporate Footer - Vitra Style
 * Minimal, professional design with clear hierarchy
 */
export function Footer() {
  const currentYear = new Date().getFullYear();

  const productLinks = [
    { label: 'Sandalyeler', href: '/products?category=chairs' },
    { label: 'Koltuklar', href: '/products?category=armchairs' },
    { label: 'Masalar', href: '/products?category=tables' },
    { label: 'Bar & Lounge', href: '/products?category=bar' },
    { label: 'Aksesuarlar', href: '/products?category=accessories' },
  ];

  const companyLinks = [
    { label: 'Hakkımızda', href: '/about' },
    { label: 'Referanslar', href: '/projects' },
    { label: 'İletişim', href: '/contact' },
  ];

  const socialLinks = [
    { icon: Instagram, href: SOCIAL_LINKS.instagram, label: 'Instagram' },
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Youtube, href: '#', label: 'YouTube' },
  ];

  return (
    <footer className="bg-charcoal text-white">
      {/* Main Footer - Compact Grid */}
      <div className="container mx-auto px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand & Contact */}
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-display text-2xl font-medium text-white">TURCO SANDALYE</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Premium mobilya üretimi
              <br />
              1985'ten bu yana
            </p>
            <a
              href="tel:+905537942161"
              className="text-gray-400 hover:text-white transition-colors text-sm"
            >
              0553 794 21 61
            </a>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-widest mb-4 text-gray-500">
              Ürünler
            </h4>
            <ul className="space-y-2">
              {productLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-widest mb-4 text-gray-500">
              Kurumsal
            </h4>
            <ul className="space-y-2">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="/catalog.pdf"
                  target="_blank"
                  className="text-gray-400 hover:text-white transition-colors text-sm inline-flex items-center gap-1"
                >
                  Katalog
                  <ArrowUpRight className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-widest mb-4 text-gray-500">
              İletişim
            </h4>
            <div className="space-y-2 text-sm text-gray-400">
              <p>Gürdinç sk 24/A</p>
              <p>Defterdar Mah, Eyüp, İstanbul</p>
              <p className="pt-2">
                <a
                  href="tel:+905537942161"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  0553 794 21 61
                </a>
              </p>
              <p>
                <a
                  href={`mailto:${SOCIAL_LINKS.email}`}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  {SOCIAL_LINKS.email}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar - Minimal */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
            {/* Copyright */}
            <p className="text-xs text-gray-500 order-2 lg:order-1">
              © {currentYear} {SITE_NAME}
            </p>

            {/* Social Links */}
            <div className="flex items-center gap-4 order-1 lg:order-2">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-white transition-colors"
                  aria-label={social.label}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>

            {/* Legal Links */}
            <div className="flex items-center gap-4 text-xs text-gray-500 order-3">
              <a href="#" className="hover:text-white transition-colors">Gizlilik</a>
              <a href="#" className="hover:text-white transition-colors">KVKK</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
